import PropTypes from "prop-types";
import React, { useState } from "react";
import Outward from "../../../assets/assets/nip_outward.svg";
import Inward from "../../../assets/assets/nip_inward.svg";
import Both from "../../../assets/assets/nip_collapse.svg";
import Button from "../../Button/Button";

const IntegrationType = (props) => {
  const { goToNext } = props;

  const [state, setstate] = useState({
    active1: false,
    active2: false,
    active3: false,
    index: "",
    selection: "",
  });

  const setActiveClass1 = (index) => {
    setstate({
      ...state,
      active1: true,
      active2: false,
      active3: false,
      selection: "outward_integration",
      index: index,
    });
  };

  const setActiveClass2 = (index) => {
    setstate({
      ...state,
      active1: false,
      active2: true,
      active3: false,
      selection: "inward_integration",
      index: index,
    });
  };

  const setActiveClass3 = (index) => {
    setstate({
      ...state,
      active1: false,
      active2: false,
      active3: true,
      selection: "inward_outward_integration",
      index: index,
    });
  };

  const selection = [
    {
      title: "Outward Only",
      logo: Outward,
      setActiveState: setActiveClass1,
    },
    {
      title: "Inward Only",
      logo: Inward,
      setActiveState: setActiveClass2,
    },
    {
      title: "Outward and Inward",
      logo: Both,
      setActiveState: setActiveClass3,
    },
  ];

  return (
    <div className="integration-type">
      <div className="nip-integration-header">Select Integration Type</div>
      <div className="integration-type-selection">
        {selection.map((item, index) => (
          <div
            data-testid={`setActive${index}`}
            className={
              (state.active1 || state.active2 || state.active3) &&
              index === state.index
                ? "integration-type-selection-box2"
                : "integration-type-selection-box"
            }
            key={index}
            onClick={() => item.setActiveState(index)}
          >
            <div className="integration-type-selection-box-image">
              <img src={item.logo} alt="logo" />
            </div>
            <span className="integration-type-selection-box-text">
              {item.title}
            </span>
          </div>
        ))}
      </div>

      <div className="integration-type-button">
        <Button
          className="button"
          type="submit"
          width="30%"
          height="50px"
          text="PROCEED"
          testId="goToNext"
          disabled={state.selection === ""}
          onClick={() => goToNext(state.selection)}
        />
      </div>
    </div>
  );
};

IntegrationType.propTypes = {
  goToNext: PropTypes.func,
};

export default IntegrationType;
